import styled from 'styled-components'
export const SocialCardContainer = styled.div`
  width: 200px !important;
  height: 160px !important;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.6rem;
  padding: 1rem;
  min-width: 140px;

  @media screen and (min-width: 1100px) {
    width: 130px !important;
    min-width: 130px !important;
    height: 145px !important;
  }
  @media screen and (min-width: 1420px) {
    width: 138px !important;
    min-width: 130px !important;
  }

  @media (width >= 1440px) {
    width: 160px !important;
    height: 140px !important;
  }
  @media screen and (width >= 1200px) {
    min-width: 100px;
    width: 135px !important;
    height: 130px !important;
  }
  @media screen and (width >= 140px) and (height >= 549px) {
    width: 160px !important;
    height: 150px !important;
  }

  @media screen and (width >= 1100px) and (height >= 549px) {
    min-width: 100px;
    width: 135px !important;
    height: 130px !important;
  }

  @media screen and (width >= 1600px) {
    width: 160px !important;
    height: 170px !important;
  }
  @media screen and (width >= 1800px) {
    width: 220px !important;
    height: 200px !important;
  }
  @media screen and (width >= 2160px) {
    width: 260px !important;
    height: 230px !important;
  }
  @media screen and (max-width: 1100px) {
    min-width: 130px;
    width: 160px;
  }
  @media screen and (width >= 2440px) {
    width: 380px !important;
    height: 320px !important;
  }
  @media screen and (width >= 2600px) {
    width: 350px !important;
    height: 300px !important;
  }

  .tweet-box-icon {
    font-size: 3rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (width >= 2440px) {
      font-size: 4rem;
    }
  }

  .tweet-box-img {
    img {
      width: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (width >= 2440px) {
        width: 64px;
      }
    }
  }
  .tweet-box-count {
    font-size: 1.1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (width >= 2440px) {
      font-size: 1.7rem;
    }
  }
  .tweet-box-title {
    font-size: 0.9rem;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (width >= 2440px) {
      font-size: 1.3rem;
    }
  }
`
